import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Main from '@/components/Main'
import Dashboard from '@/view/Dashboard'
import ListNarasumber from '@/view/Narasumber/ListNarasumber'
import FormNarasumber from '@/view/Narasumber/FormNarasumber'
import ListSejarah from '@/view/Profile/Sejarah/ListSejarah'
import FormSejarah from '@/view/Profile/Sejarah/FormSejarah'
import ListVisiMisi from '@/view/Profile/VisiMisi/ListVisiMisi'
import FormVisiMisi from '@/view/Profile/VisiMisi/FormVisiMisi'
import ListPendiri from '@/view/Profile/Pendiri/ListPendiri'
import FormPendiri from '@/view/Profile/Pendiri/FormPendiri'
import FormStrukturOrganisasi from '@/view/Profile/StrukturOrganisasi/FormStrukturOrganisasi'
import ListPDP from '@/view/Unduh/PDP/ListPDP'
import FormPDP from '@/view/Unduh/PDP/FormPDP'
import ListRegulasi from '@/view/Unduh/Regulasi/ListRegulasi'
import FormRegulasi from '@/view/Unduh/Regulasi/FormRegulasi'
import ListMajalah from '@/view/Unduh/Majalah/ListMajalah'
import FormMajalah from '@/view/Unduh/Majalah/FormMajalah'
import ListMateriKomunikasi from '@/view/Unduh/MateriKomunikasi/ListMateriKomunikasi'
import FormMateriKomunikasi from '@/view/Unduh/MateriKomunikasi/FormMateriKomunikasi'
import ListUnduh from '@/view/Unduh/Unduh/ListUnduh'
import FormUnduh from '@/view/Unduh/Unduh/FormUnduh'
import ListDownload from '@/view/Informasi/Download/ListDownload'
import FormDownload from '@/view/Informasi/Download/FormDownload'
import ListKegiatan from '@/view/Informasi/Kegiatan/ListKegiatan'
import FormKegiatan from '@/view/Informasi/Kegiatan/FormKegiatan'
import HubungiKami from '@/view/Informasi/HubungiKami'
import Galeri from '@/view/Informasi/Galeri'
import FormGaleri from '@/view/Informasi/FormGaleri'
import ListWhistleBlower from '@/view/ListWhistleBlower'
import FormWhistleBlower from '@/view/FormWhistleBlower'
import Notifikasi from '@/view/Notifikasi'
import Headline from '@/view/Headline'
import ListSlider from '@/view/ListSlider'
import FormSlider from '@/view/FormSlider'
import ListAnakPerusahaan from '@/view/ListAnakPerusahaan'
import FormAnakPerusahaan from '@/view/FormAnakPerusahaan'
import ListFaq from '@/view/Faq/ListFaq'
import FormFaq from '@/view/Faq/FormFaq'
import ListSurvey from '@/view/Survey/ListSurvey'
import FormSurvey from '@/view/Survey/FormSurvey'
import HasilSurvey from '@/view/Survey/HasilSurvey'
import ListIdentitasPemotong from '@/view/IdentitasPemotong/ListIdentitasPemotong'
import FormIdentitasPemotong from '@/view/IdentitasPemotong/FormIdentitasPemotong'
import Upload from '@/view/Upload'
import LupaPassword from '@/components/LupaPassword'
import ResetPassword from '@/components/ResetPassword'

import ListKelengkapan from '@/view/ListKelengkapan'
import ListAnggota from '@/view/Anggota/ListAnggota'
import TambahAnggota from '@/view/Anggota/TambahAnggota'
import EditAnggota from '@/view/Anggota/EditAnggota'

import ListAdmin from '@/view/Admin/ListAdmin'
import FormAdmin from '@/view/Admin/FormAdmin'

import ListLog from '@/view/ListLog'

import Form from '@/view/Form'

import vbclass from 'vue-body-class'
import Artikel from '../view/Informasi/Artikel/Artikel.vue'
import ListArtikel from '../view/Informasi/Artikel/ListArtikel.vue'
import KritikDanSaranList from '../view/KritikdanSaran/KritikDanSaranList.vue'
import KritikDanSaran from '../view/KritikdanSaran/KritikDanSaran.vue'
import Pengaduan from '../view/Pengaduan/Pengaduan.vue'
import PengaduanList from '../view/Pengaduan/PengaduanList.vue'
import PengumumanList from '../view/Pengumuman/PengumumanList.vue'
import FormPengumuman from '../view/Pengumuman/Pengumuman.vue'
// import ListBanner from '../view/Banners/ListBanner.vue'
import PintasanInformasi from '../view/PintasanInformasi/PintasanInformasi.vue'
import ListPintasanInformasi from '../view/PintasanInformasi/ListPintasanInformasi.vue'
import ListBanner from '../view/Banners/ListBanner.vue'
import Banner from '../view/Banners/Banner.vue'
import Calender from '../view/Kalender/Calender.vue'
import CetakApprove from '../view/CetakApprove.vue'
import ListHakdanKewajiban from '../view/HakdanKewajiban/ListHakdanKewajiban.vue'
import FormHakdanKewajiban from '../view/HakdanKewajiban/FormHakdanKewajiban.vue'
import PensiunTypeList from '../view/PensiunRegistrasi/PensiunTypeList.vue'
import FormPensiunType from '../view/PensiunRegistrasi/FormPensiunType.vue'
import CategoryFaq from '../view/Faq/CategoryFaq.vue'
import ListCategoryFaq from '../view/Faq/ListCategoryFaq.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/login', name: 'Login', component: Login, meta: { bodyClass: 'login-page', noRequiredAuth: true } },
    { path: '/lupa-password', name: 'LupaPassword', component: LupaPassword, meta: { bodyClass: 'login-page', noRequiredAuth: true } },
    { path: '/reset-password/:token', name: 'ResetPassword', component: ResetPassword, meta: { bodyClass: 'login-page', noRequiredAuth: true } },
    { path: '/', redirect: '/login', meta: { noRequiredAuth: true } },
    { path: '*', redirect: '/', meta: { noRequiredAuth: true } },
    {
      path: '/main',
      component: Main,
      meta: {
        bodyClass: 'theme-red'
      },
      children: [
        { path: 'dashboard', name: 'Dashboard', component: Dashboard },
        // Narasumber
        { path: 'narasumber', name: 'ListNarasumber', component: ListNarasumber },
        { path: 'narasumber/tambah', name: 'TambahNarasumber', component: FormNarasumber },
        { path: 'narasumber/edit/:id', name: 'EditNarasumber', component: FormNarasumber },
        // Visi Misi
        { path: 'profile/visi-misi', name: 'ListVisiMisi', component: ListVisiMisi },
        { path: 'profile/visi-misi/tambah', name: 'TambahVisiMisi', component: FormVisiMisi },
        { path: 'profile/visi-misi/edit/:id', name: 'EditVisiMisi', component: FormVisiMisi },
        // Pendiri
        { path: 'profile/pendiri', name: 'ListPendiri', component: ListPendiri },
        { path: 'profile/pendiri/tambah', name: 'TambahPendiri', component: FormPendiri },
        { path: 'profile/pendiri/edit/:id', name: 'EditPendiri', component: FormPendiri },
        // Dewan Pengawas
        { path: 'profile/dewan-pengawas', name: 'ListDewanPengawas', component: ListPendiri },
        { path: 'profile/dewan-pengawas/tambah', name: 'TambahDewanPengawas', component: FormPendiri },
        { path: 'profile/dewan-pengawas/edit/:id', name: 'EditDewanPengawas', component: FormPendiri },
        // Pengurus
        { path: 'profile/pengurus', name: 'ListPengurus', component: ListPendiri },
        { path: 'profile/pengurus/tambah', name: 'TambahPengurus', component: FormPendiri },
        { path: 'profile/pengurus/edit/:id', name: 'EditPengurus', component: FormPendiri },
        // Sejarah
        { path: 'profile/sejarah', name: 'ListSejarah', component: ListSejarah },
        { path: 'profile/sejarah/tambah', name: 'TambahSejarah', component: FormSejarah },
        { path: 'profile/sejarah/edit/:id', name: 'EditSejarah', component: FormSejarah },
        // Struktur Organisasi
        { path: 'profile/struktur-organisasi', name: 'StrukturOrganisasi', component: FormStrukturOrganisasi },
        // Budaya Kerja
        { path: 'profile/budaya-kerja', name: 'ListBudayaKerja', component: ListVisiMisi },
        { path: 'profile/budaya-kerja/tambah', name: 'TambahBudayaKerja', component: FormVisiMisi },
        { path: 'profile/budaya-kerja/edit/:id', name: 'EditBudayaKerja', component: FormVisiMisi },
        // Informasi Kegiatan
        { path: 'informasi/kegiatan', name: 'ListKegiatan', component: ListKegiatan },
        { path: 'informasi/kegiatan/tambah', name: 'TambahKegiatan', component: FormKegiatan },
        { path: 'informasi/kegiatan/edit/:id', name: 'EditKegiatan', component: FormKegiatan },
        // Informasi artikel
        { path: 'informasi/artikel', name: 'ListArtikel', component: ListArtikel },
        { path: 'informasi/artikel/tambah', name: 'TambahArtikel', component: Artikel },
        { path: 'informasi/artikel/edit/:id', name: 'EditArtikel', component: Artikel },

        { path: 'informasi/perkembangan', name: 'ListPerkembangan', component: ListDownload },
        { path: 'informasi/perkembangan/tambah', name: 'TambahPerkembangan', component: FormDownload },
        { path: 'informasi/perkembangan/edit/:id', name: 'EditPerkembangan', component: FormDownload },
        // Galeri
        { path: 'informasi/galeri', name: 'Galeri', component: Galeri },
        { path: 'informasi/galeri/tambah', name: 'TambahGaleri', component: FormGaleri },
        { path: 'informasi/galeri/edit/:id', name: 'EditGaleri', component: FormGaleri },
        // Informasi Tahunan
        { path: 'informasi/tahunan', name: 'ListTahunan', component: ListDownload },
        { path: 'informasi/tahunan/tambah', name: 'TambahTahunan', component: FormDownload },
        { path: 'informasi/tahunan/edit/:id', name: 'EditTahunan', component: FormDownload },
        // Informasi Lowongan
        { path: 'informasi/lowongan', name: 'ListLowongan', component: ListDownload },
        { path: 'informasi/lowongan/tambah', name: 'TambahLowongan', component: FormDownload },
        { path: 'informasi/lowongan/edit/:id', name: 'EditLowongan', component: FormDownload },
        // PDP
        { path: 'unduh/pdp', name: 'ListPDP', component: ListPDP },
        { path: 'unduh/pdp/tambah', name: 'TambahPDP', component: FormPDP },
        { path: 'unduh/pdp/edit/:id', name: 'EditPDP', component: FormPDP },
        // Arahan
        { path: 'unduh/arahan', name: 'ListArahan', component: ListPDP },
        { path: 'unduh/arahan/tambah', name: 'TambahArahan', component: FormPDP },
        { path: 'unduh/arahan/edit/:id', name: 'EditArahan', component: FormPDP },
        // Regulasi
        { path: 'unduh/regulasi', name: 'ListRegulasi', component: ListRegulasi },
        { path: 'unduh/regulasi/tambah', name: 'TambahRegulasi', component: FormRegulasi },
        { path: 'unduh/regulasi/edit/:id', name: 'EditRegulasi', component: FormRegulasi },
        // Majalah
        { path: 'unduh/majalah', name: 'ListMajalah', component: ListMajalah },
        { path: 'unduh/majalah/tambah', name: 'TambahMajalah', component: FormMajalah },
        { path: 'unduh/majalah/edit/:id', name: 'EditMajalah', component: FormMajalah },
        // MateriKomunikasi
        { path: 'unduh/materiKomunikasi', name: 'ListMateriKomunikasi', component: ListMateriKomunikasi },
        { path: 'unduh/materiKomunikasi/tambah', name: 'TambahMateriKomunikasi', component: FormMateriKomunikasi },
        { path: 'unduh/materiKomunikasi/edit/:id', name: 'EditMateriKomunikasi', component: FormMateriKomunikasi },
        // Laporan
        { path: 'unduh/laporan', name: 'ListLaporan', component: ListUnduh },
        { path: 'unduh/laporan/tambah', name: 'TambahLaporan', component: FormUnduh },
        { path: 'unduh/laporan/edit/:id', name: 'EditLaporan', component: FormUnduh },
        // Formulir
        { path: 'unduh/formulir', name: 'ListFormulir', component: ListUnduh },
        { path: 'unduh/formulir/tambah', name: 'TambahFormulir', component: FormUnduh },
        { path: 'unduh/formulir/edit/:id', name: 'EditFormulir', component: FormUnduh },
        // HubungiKami
        { path: 'whistleblower', name: 'ListWhistleBlower', component: ListWhistleBlower },
        { path: 'whistleblower/tambah', name: 'TambahWhistleBlower', component: FormWhistleBlower },
        { path: 'whistleblower/edit/:id', name: 'EditWhistleBlowern', component: FormWhistleBlower },
        // Slider
        { path: 'slider', name: 'ListSlider', component: ListSlider },
        { path: 'slider/tambah', name: 'TambahSlider', component: FormSlider },
        { path: 'slider/edit/:id', name: 'EditSlider', component: FormSlider },
        // Anak Perusahaan
        { path: 'anak-perusahaan', name: 'ListAnakPerusahaan', component: ListAnakPerusahaan },
        { path: 'anak-perusahaan/tambah', name: 'TambahAnakPerusahaan', component: FormAnakPerusahaan },
        { path: 'anak-perusahaan/edit/:id', name: 'EditAnakPerusahaan', component: FormAnakPerusahaan },
        // FaQ
        { path: 'faq', name: 'ListFaq', component: ListFaq },
        { path: 'faq/tambah', name: 'TambahFaq', component: FormFaq },
        { path: 'faq/TambahFaqCategory', name: 'TambahFaqCategory', component: CategoryFaq },
        { path: 'faq/Categoryfaq', name: 'ListCategoryFaq', component: ListCategoryFaq },
        { path: 'faq/editCategory/:id', name: 'EditFaqCategory', component: CategoryFaq },
        // LOG
        { path: 'log', name: 'ListLog', component: ListLog },
        // Kelengkapan
        { path: 'layanan/kelengkapan', name: 'ListKelengkapan', component: ListKelengkapan },
        // Survey
        { path: 'syarat', name: 'SyaratKepesertaan', component: Form },
        { path: 'cara', name: 'CaraMendaftar', component: Form },
        { path: 'faq/edit/:id', name: 'EditFaq', component: FormFaq },
        { path: 'layanan/survey', name: 'ListSurvey', component: ListSurvey },
        { path: 'layanan/survey/tambah', name: 'TambahSurvey', component: FormSurvey },
        { path: 'layanan/survey/edit/:id', name: 'EditSurvey', component: FormSurvey },
        { path: 'layanan/survey/hasil', name: 'HasilSurvey', component: HasilSurvey },
        { path: 'layanan/KritikDanSaran', name: 'KritikDanSaran', component: KritikDanSaranList },
        { path: 'layanan/KritikDanSaran/:id', name: 'EditKritikDanSaran', component: KritikDanSaran },
        { path: 'layanan/Pengaduan/', name: 'Pengaduan', component: PengaduanList },
        { path: 'layanan/Pengaduan/edit/:id', name: 'EditPengaduan', component: Pengaduan },
        // Informasi Perkembangan
        // cetak Approve
        { path: 'layanan/cetakMP/', name: 'cetakMP', component: CetakApprove },

        // pengumuman
        { path: 'pengumuman/pengumuman', name: 'ListPengumuman', component: PengumumanList },
        { path: 'pengumuman/pengumuman/tambah', name: 'TambahPengumuman', component: FormPengumuman },
        { path: 'pengumuman/pengumuman/edit/:id', name: 'EditPengumuman', component: FormPengumuman },

        // pensiunType
        { path: 'pensiunRegistrasi/pensiuntype', name: 'ListPensiuntype', component: PensiunTypeList },
        { path: 'pensiunRegistrasi/pensiuntype/tambah', name: 'TambahPensiunType', component: FormPensiunType },
        { path: 'pensiunRegistrasi/pensiuntype/edit/:id', name: 'EditPensiunType', component: FormPensiunType },
        // hak dan kewajiban
        { path: 'HakdanWajiban/ListHakdanKewajiban', name: 'ListHakKewajiban', component: ListHakdanKewajiban },
        { path: 'HakdanWajiban/ListHakdanKewajiban/tambah', name: 'TambahHakKewajiabn', component: FormHakdanKewajiban },
        { path: 'HakdanWajiban/ListHakdanKewajiban/edit/:id', name: 'EditHakKewajiban', component: FormHakdanKewajiban },
        // Banner
        { path: 'banner', name: 'ListBanner', component: ListBanner },
        { path: 'banner/tambah', name: 'TambahBanner', component: Banner },
        { path: 'banner/edit/:id', name: 'EditBanner', component: Banner },

        // kalender
        { path: 'calender', name: 'calender', component: Calender },

        { path: 'pintasanInformasi', name: 'ListPintasInfromasi', component: ListPintasanInformasi },
        { path: 'pintasanInformasi/edit/:id', name: 'EditPintasInformasi', component: PintasanInformasi },
        // IP
        { path: 'layanan/atur-ip', name: 'ListIdentitasPemotong', component: ListIdentitasPemotong },
        { path: 'layanan/atur-ip/tambah', name: 'TambahIdentitasPemotong', component: FormIdentitasPemotong },
        { path: 'layanan/atur-ip/edit/:id', name: 'EditIdentitasPemotong', component: FormIdentitasPemotong },
        // HubungiKami
        { path: 'hubungi-kami', name: 'HubungiKami', component: HubungiKami },
        // Other
        { path: 'notification', name: 'Notification', component: Notifikasi },
        { path: 'headline', name: 'Headline', component: Headline },
        { path: 'layanan/cetak-struk-mp', name: 'CetakStrukMP', component: Upload },
        { path: 'layanan/cetak-struk-uang-pembinaan', name: 'CetakStrukUangPembinaan', component: Upload },
        { path: 'layanan/cetak-struk-rapel', name: 'CetakStrukRapel', component: Upload },
        { path: 'layanan/cetak-spt', name: 'CetakSPT', component: Upload },
        // Anggota
        { path: 'anggota', name: 'ListAnggota', component: ListAnggota },
        { path: 'anggota/tambah', name: 'TambahAnggota', component: TambahAnggota },
        { path: 'anggota/edit/:id', name: 'EditAnggota', component: EditAnggota },
        // Admin
        { path: 'admin', name: 'ListAdmin', component: ListAdmin },
        { path: 'admin/tambah', name: 'TambahAdmin', component: FormAdmin },
        { path: 'admin/edit/:id', name: 'EditAdmin', component: FormAdmin }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.noRequiredAuth)) {
    next()
  } else {
    var token = localStorage.getItem('_token')
    if (token === null || token === '') {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  }
})

export default router
Vue.router = router

Vue.use(vbclass, router)



// WEBPACK FOOTER //
// ./src/router/index.js